export default __webpack_public_path__ + "static/media/rabbit-green.bee66118.svg";